

import React from 'react'
import {Container, Row, Col } from 'reactstrap';
import "./Library.css"
import tapa from "../../assets/images/tapa.jpeg"

const Library = () => {
    const handleClick = ()=>{
        window.open('https://www.amazon.com/-/es/Cecilia-Vivanco/dp/9878874672/ref=sr_1_1?__mk_es_US=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=1KQHF96XM5BYJ&keywords=la+hoja+cortada+cecilia+vivanco&qid=1689176378&sprefix=la+hoja+cortada+cecilia+vivanco%2Caps%2C237&sr=8-1', '_blank')
        }
    return <><section className="library-section">
        <Container>
            <Row>
                {/*   <Col lg='12' md='12'>    */}
                <div className="location_section-content">
                    <h2 className="section_title"> ¿Dónde encontrarlo? </h2>
                    <p className="section_description"><i class="ri-map-pin-line"></i> — DANY LIBROS — Córdoba 678, local 18 (San Miguel de Tucumán, Tucumán, Argentina). De 09:30 a 13:00hs y de 17:30 a 20:30hs. </p>
                    <p className="section_description"><i class="ri-map-pin-line"></i> — NUESTRO ARCON — Armenia 1555, Palermo (Ciudad Autónoma de Buenos Aires, Argentina). Miércoles a domingos de 15:00 a 19:00 hs. </p>
                    <p className="section_description"><i class="ri-motorbike-fill"></i> — Envíos a toda la Argentina — contactarse con la autora </p>
                    <p className="section_description"> <i class="ri-earth-fill"></i> — Envíos a otros países —   <button onClick={handleClick} className="btn-amazon"> AMAZON<i class="ri-arrow-right-double-line"></i></button> </p>
                </div>
                {/*</Col>*/}
            </Row>
        </Container>
    </section>

    {/* ===========SECTION TAPA DEL LIBRO- HOME =========== */}
    <section className="book-section">
        <Container>
            <Row>
                <Col lg='6' md='6'>
                    <img src={tapa} alt="tapa del libro" className='tapaLibro' />
                </Col>
                <Col lg='6' md='6'className="">
                    <div>
                        <p className="contratapa"><i class="ri-double-quotes-l"></i>Cuando se callan momentos de profundo dolor de una historia familiar, es posible que algún integrante de la familia, por necesidad, por un impulso desconocido o empujado simplemente por la curiosidad, oficie de mago, sacando de la galera lo que nunca se quiso o quizá no se pudo mostrar. Este acto puede dar lugar a múltiples miradas, pero algo ha cambiado para siempre. El devenir de esta familia ya no es el mismo, porque se ha dado voz a quien no la tenía y se ha mostrado una realidad antes silenciada. </p>
                        <p className="contratapa">El germen de La Hoja Cortada es el silencio y una voluntad de transformarlo en identidad, que oficia como muestra de señera justicia.<i class="ri-double-quotes-r"></i></p>
                    </div>
                </Col>
            </Row>
        </Container>
        </section></>
}

export default Library